import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect, useHistory } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import axios from 'axios';

import './historicoSati.css';
import ListaAnexos from '../Components/ListaAnexos/listaAnexos';
import ChamadoAttachmentField from '../../Solicitante/NovaSati/components/ChamadoAttachmentField';
import { mensagemErroAnexo } from '../../FuncoesGerais/anexoArquivo';
import { ChamadoPage } from '../Chamado';
import DesenvolvimentoCard from '../Components/Desenvolvimento/DesenvolvimentoCard';
import ApontamentosCard from '../Components/Worklog/ApontamentosCard';

import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../config/backend';
import { useStatusChamado } from '../../hooks/useStatusChamado';
import { isStatusChamadoFechado } from '../../api/statusChamado';
import { useTiposChamado } from '../../hooks/useTiposChamado';
import { ModalAlert, ModalConfirm } from '../Components/ModalSistema';

function HistoricoSati(props) {

    const history = useHistory();

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    const [data, setData] = useState([]);
    const [satDesHis, setSatDesHis] = useState('');
    const [sucesso, setSucesso] = useState('N');
    let [satNum, setSatNum] = useState(0);
    const [satDesSol, setSatDesSol] = useState('');
    const [satAntSol, setSatAntSol] = useState('');
    const [anexos, setAnexos] = useState([]);
    const [novoAnexoBase64, setNovoAnexoBase64] = useState('');
    const [novoAnexoNome, setNovoAnexoNome] = useState('');
    const [novoAnexoInterno, setNovoAnexoInterno] = useState(false);
    const [salvandoAnexo, setSalvandoAnexo] = useState(false);
    const [marcado, setMarcado] = useState(false);
    const [comentarioInterno, setComentarioInterno] = useState(false);

    const [nomSis, setNomSis] = useState('');
    const [codEqp, setCodEqp] = useState('0');
    const [, setNomEqp] = useState('');
    const [tipoNome, setTipoNome] = useState('');
    const [tipoId, setTipoId] = useState(null);
    const [showModalTipo, setShowModalTipo] = useState(false);
    const [tipoIdAtual, setTipoIdAtual] = useState('');
    const [salvandoTipo, setSalvandoTipo] = useState(false);
    const [, setPrazoEmHoras] = useState(null);
    const [, setDataAberturaSati] = useState(null);
    const [sugestaoSolucao, setSugestaoSolucao] = useState('');
    const [sugestaoSolucaoLoading, setSugestaoSolucaoLoading] = useState(false);
    const [sugestaoSolucaoMensagem, setSugestaoSolucaoMensagem] = useState('');
    const [chamadosRelacionados, setChamadosRelacionados] = useState([]);
    const [reverRespostaLoading, setReverRespostaLoading] = useState(false);
    const [resumoChamado, setResumoChamado] = useState('');
    const [resumoOrigem, setResumoOrigem] = useState('ia');
    const [resumoLoading, setResumoLoading] = useState(false);
    const [prioridadeSugerida, setPrioridadeSugerida] = useState(null);
    const [, setOrdensPrioridade] = useState([]);
    const [, setOrdensComNome] = useState([]);
    const [nomeSugeridoPrioridade, setNomeSugeridoPrioridade] = useState('');
    const [prioridadeLoading, setPrioridadeLoading] = useState(false);
    const [, setSugestaoResposta] = useState('');
    const [sugestaoRespostaLoading, setSugestaoRespostaLoading] = useState(false);
    const [proximosPassosLoading, setProximosPassosLoading] = useState(false);
    const [tempoTrabalhadoTexto, setTempoTrabalhadoTexto] = useState('');
    const [tempoTrabalhadoMinutos, setTempoTrabalhadoMinutos] = useState(0);
    const [tempoAnaliseTexto, setTempoAnaliseTexto] = useState('');
    const [tempoAnaliseMinutos, setTempoAnaliseMinutos] = useState(0);
    const [tempoTesteTexto, setTempoTesteTexto] = useState('');
    const [tempoTesteMinutos, setTempoTesteMinutos] = useState(0);
    const [abaAtiva, setAbaAtiva] = useState('ATENDIMENTO');
    const [emPeriodoAberto, setEmPeriodoAberto] = useState(false);
    const [emPeriodoAbertoAnalise, setEmPeriodoAbertoAnalise] = useState(false);
    const [emPeriodoAbertoTeste, setEmPeriodoAbertoTeste] = useState(false);
    const [statusAtual, setStatusAtual] = useState(null);
    const [atendenteNome, setAtendenteNome] = useState('');
    const [solicitanteNome, setSolicitanteNome] = useState('');
    const tempoTrabalhadoBaseRef = useRef({ baseMinutos: 0, baseTimestamp: 0 });
    const tempoAnaliseBaseRef = useRef({ baseMinutos: 0, baseTimestamp: 0 });
    const tempoTesteBaseRef = useRef({ baseMinutos: 0, baseTimestamp: 0 });
    const descricaoTextareaRef = useRef(null);
    const analiseTextareaRef = useRef(null);
    const testeTextareaRef = useRef(null);
    const [descricaoAnaliseRequisitos, setDescricaoAnaliseRequisitos] = useState('');
    const [salvandoAnalise, setSalvandoAnalise] = useState(false);
    const [descricaoConsideracoesTeste, setDescricaoConsideracoesTeste] = useState('');
    const [salvandoConsideracoesTeste, setSalvandoConsideracoesTeste] = useState(false);
    const [sprintId, setSprintId] = useState(null);
    const [sprintNome, setSprintNome] = useState('');
    const [estimativaHoras, setEstimativaHoras] = useState(null);
    const [usaSprint, setUsaSprint] = useState(false);
    const [colaboradores, setColaboradores] = useState([]);
    const [novoColaboradorId, setNovoColaboradorId] = useState('');
    const [opcoesColaboradores, setOpcoesColaboradores] = useState([]);
    const [novoResponsavelId, setNovoResponsavelId] = useState('');
    const [salvandoAtribuicaoAtendente, setSalvandoAtribuicaoAtendente] = useState(false);
    const [carregandoOpcoesColaboradores, setCarregandoOpcoesColaboradores] = useState(false);
    const [carregandoColaboradores, setCarregandoColaboradores] = useState(false);
    const [salvandoColaborador, setSalvandoColaborador] = useState(false);
    const [modalAlert, setModalAlert] = useState({ show: false, title: 'Aviso', message: '' });
    const [modalConfirm, setModalConfirm] = useState({ show: false, title: '', message: '' });
    const confirmCallbackRef = useRef(null);

    const iaHabilitada = localStorage.getItem('ia_habilitada') !== '0';
    const { statusParaSelect, getNome: getNomeStatus, statusList } = useStatusChamado();
    const { tipos: tiposChamado } = useTiposChamado();
    const chamadoId = props.match.params.id;

    useEffect(() => {
        if (statusAtual == null || !statusList.length) return;
        if (isStatusChamadoFechado(statusList, statusAtual)) {
            history.replace(`/historicoSatiFechada/${chamadoId}`);
        }
    }, [statusAtual, statusList, chamadoId, history]);

    const formatarTempoSegundos = (totalSegundos) => {
        const s = Math.max(0, Math.floor(totalSegundos));
        const h = Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        const seg = s % 60;
        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(h)}:${pad(m)}:${pad(seg)}`;
    };

    useEffect(() => {
        if (!emPeriodoAberto) return;
        const tick = () => {
            const { baseMinutos, baseTimestamp } = tempoTrabalhadoBaseRef.current;
            const totalSegundos = baseMinutos * 60 + (Date.now() - baseTimestamp) / 1000;
            setTempoTrabalhadoTexto(formatarTempoSegundos(totalSegundos));
        };
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [emPeriodoAberto]);

    useEffect(() => {
        if (!emPeriodoAbertoAnalise) return;
        const tick = () => {
            const { baseMinutos, baseTimestamp } = tempoAnaliseBaseRef.current;
            const totalSegundos = baseMinutos * 60 + (Date.now() - baseTimestamp) / 1000;
            setTempoAnaliseTexto(formatarTempoSegundos(totalSegundos));
        };
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [emPeriodoAbertoAnalise]);

    useEffect(() => {
        if (!statusAtual) {
            setEmPeriodoAbertoAnalise(false);
            return;
        }
        const nomeStatusAtual = (getNomeStatus(statusAtual) || '')
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        const emAnaliseAgora = nomeStatusAtual.includes('ANALISE');
        if (emAnaliseAgora) {
            setEmPeriodoAbertoAnalise(true);
            tempoAnaliseBaseRef.current = { baseMinutos: tempoAnaliseMinutos, baseTimestamp: Date.now() };
            const totalSegundosAnalise = tempoAnaliseMinutos * 60;
            setTempoAnaliseTexto(formatarTempoSegundos(totalSegundosAnalise));
        } else {
            setEmPeriodoAbertoAnalise(false);
        }
    }, [statusAtual, tempoAnaliseMinutos, getNomeStatus]);

    useEffect(() => {
        if (!statusAtual) {
            setEmPeriodoAbertoTeste(false);
            return;
        }
        const nomeStatusAtual = (getNomeStatus(statusAtual) || '')
            .toUpperCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        const emTesteAgora = nomeStatusAtual.includes('TESTE');
        if (emTesteAgora) {
            setEmPeriodoAbertoTeste(true);
            tempoTesteBaseRef.current = { baseMinutos: tempoTesteMinutos, baseTimestamp: Date.now() };
            const totalSegundosTeste = tempoTesteMinutos * 60;
            setTempoTesteTexto(formatarTempoSegundos(totalSegundosTeste));
        } else {
            setEmPeriodoAbertoTeste(false);
        }
    }, [statusAtual, tempoTesteMinutos, getNomeStatus]);

    useEffect(() => {
        if (!emPeriodoAbertoTeste) return;
        const tick = () => {
            const { baseMinutos, baseTimestamp } = tempoTesteBaseRef.current;
            const totalSegundos = baseMinutos * 60 + (Date.now() - baseTimestamp) / 1000;
            setTempoTesteTexto(formatarTempoSegundos(totalSegundos));
        };
        tick();
        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [emPeriodoAbertoTeste]);

    const MIN_ALTURA_DESCRICAO = 220;
    const MIN_ALTURA_ANALISE = 220;
    const MAX_ALTURA_ANALISE = 540;
    const MIN_ALTURA_TESTE = 220;
    const MAX_ALTURA_TESTE = 540;

    const ajustarAlturaDescricao = () => {
        const el = descricaoTextareaRef.current;
        if (!el) return;
        el.style.height = '1px';
        el.style.height = `${Math.max(MIN_ALTURA_DESCRICAO, el.scrollHeight)}px`;
    };

    const ajustarAlturaAnalise = () => {
        const el = analiseTextareaRef.current;
        if (!el) return;
        el.style.height = '1px';
        const novaAltura = Math.max(MIN_ALTURA_ANALISE, el.scrollHeight);
        el.style.height = `${Math.min(MAX_ALTURA_ANALISE, novaAltura)}px`;
    };

    const ajustarAlturaTeste = () => {
        const el = testeTextareaRef.current;
        if (!el) return;
        el.style.height = '1px';
        const novaAltura = Math.max(MIN_ALTURA_TESTE, el.scrollHeight);
        el.style.height = `${Math.min(MAX_ALTURA_TESTE, novaAltura)}px`;
    };

    useEffect(() => {
        const t = setTimeout(() => {
            if (abaAtiva === 'ATENDIMENTO') ajustarAlturaDescricao();
            else if (abaAtiva === 'ANALISE') ajustarAlturaAnalise();
            else if (abaAtiva === 'TESTE') ajustarAlturaTeste();
        }, 50);
        return () => clearTimeout(t);
    }, [abaAtiva, satDesSol, descricaoAnaliseRequisitos, descricaoConsideracoesTeste]);

    const anexosCardRef = useRef(null);
    const openAnexo = () => {
        anexosCardRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const adicionarAnexoNoCard = async () => {
        const id = props.match.params.id;
        if (!id || !novoAnexoBase64 || !novoAnexoNome?.trim()) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        const baseUrl = ensureProtocol(localStorage.getItem('ipBackend2'));
        if (!baseUrl) return;
        setSalvandoAnexo(true);
        try {
            await axios.post(baseUrl + '/anexos', {
                satNum: id,
                nomArq: novoAnexoNome.trim(),
                Arquivo64: novoAnexoBase64,
                interno: novoAnexoInterno,
            }, { headers: { Authorization: token } });
            setNovoAnexoBase64('');
            setNovoAnexoNome('');
            setNovoAnexoInterno(false);
            fetchAnexos();
            fetchData();
        } catch (err) {
            console.error('Erro ao adicionar anexo:', err);
            setModalAlert({ show: true, title: 'Erro', message: mensagemErroAnexo(err) });
        } finally {
            setSalvandoAnexo(false);
        }
    };

    const excluirAnexoNoCard = (seqAne) => {
        confirmCallbackRef.current = async () => {
            verificandoToken();
            const token = localStorage.getItem('token');
            const baseUrl = ensureProtocol(localStorage.getItem('ipBackend2'));
            if (!baseUrl) return;
            try {
                await axios.delete(baseUrl + '/anexos', {
                    headers: { Authorization: token },
                    params: { seqAne },
                });
                fetchAnexos();
            } catch (err) {
                console.error('Erro ao excluir anexo:', err);
                setModalAlert({ show: true, title: 'Erro', message: err.response?.data?.error || 'Erro ao excluir anexo.' });
            }
        };
        setModalConfirm({ show: true, title: 'Excluir anexo', message: 'Excluir este anexo?' });
    };

    const fetchAnexos = async () => {
        const id = props.match.params.id;
        if (!id) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/anexos", {
                headers: { Authorization: `${token}` },
                params: { satNum: id }
            });
            const lista = Array.isArray(response.data) ? response.data : [];
            setAnexos(lista.map(item => ({
                satNum: item.SATNUM ?? item.satNum,
                seqAne: item.SEQANE ?? item.seqAne,
                seqHis: item.SEQHIS ?? item.seqHis,
                nomArq: item.NOMARQ ?? item.nomArq,
                arquivo: item.ARQUIVO ?? item.arquivo ?? item.Arquivo64,
                interno: !!(item.INTERNO === 1 || item.interno === 1)
            })));
        } catch (err) {
            console.error('Erro ao buscar anexos:', err);
            setAnexos([]);
        }
    };

    const fetchColaboradores = async () => {
        const id = props.match.params.id;
        if (!id) return;
        const baseUrl = baseUrlAnalista();
        if (!baseUrl) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        setCarregandoColaboradores(true);
        try {
            const response = await axios.get(baseUrl + `/satis/${id}/colaboradores`, {
                headers: { Authorization: `${token}` }
            });
            const lista = Array.isArray(response.data) ? response.data : [];
            setColaboradores(lista.map((c) => ({
                id: c.id,
                nome: c.nome || '',
                papel: c.papel || null,
                grupo: c.grupo || null,
                situacao: c.situacao || null,
                data_inclusao: c.data_inclusao || null,
                usuario_inclusao_id: c.usuario_inclusao_id ?? null,
            })));
        } catch (err) {
            console.error('Erro ao buscar colaboradores:', err);
            setColaboradores([]);
        } finally {
            setCarregandoColaboradores(false);
        }
    };

    const fetchOpcoesColaboradores = async () => {
        const baseUrl = baseUrlAnalista();
        if (!baseUrl) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        setCarregandoOpcoesColaboradores(true);
        try {

            const responseAnalistas = await axios.get(baseUrl + '/usuarios/analistas', {
                headers: { Authorization: `${token}` }
            });
            const listaAnalistas = Array.isArray(responseAnalistas.data) ? responseAnalistas.data : [];
            setOpcoesColaboradores(listaAnalistas.map((u) => ({
                id: u.USUSEQ ?? u.ususeq ?? u.id,
                nome: u.USRNOMCPL ?? u.usrnomcpl ?? u.nome ?? '',
                tipo_analista: u.tipo_analista ?? null,
                eh_suporte: u.eh_suporte,
                eh_desenvolvedor: u.eh_desenvolvedor,
            })));
        } catch (err) {
            console.error('Erro ao carregar opções de colaboradores:', err);
            setOpcoesColaboradores([]);
        } finally {
            setCarregandoOpcoesColaboradores(false);
        }
    };

    useEffect(() => {
        fetchOpcoesColaboradores();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchData = async () => {

        let listaHistorico = [];

        satNum = props.match.params.id;

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satHis", {
                headers: {
                    Authorization: `${token}`
                }, params: {
                    satNum: satNum
                }
            });
            const rows = Array.isArray(response.data) ? response.data : [];
            for (let i = 0; i < rows.length; i++) {
                const r = rows[i];
                listaHistorico.push({
                    descricao: r.SATDESSLI ?? r.satdessli ?? '',
                    data: r.SATDATFEC ?? r.satdatfec ?? '',
                    codHis: r.CODHIS ?? r.codhis,
                    autor_nome: r.autor_nome ?? r.AUTOR_NOME ?? null,
                    interno: !!(r.INTERNO === 1 || r.interno === 1)
                });
            }
            setData(listaHistorico);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const retornarSistema = async (satNum) => {

        let codSis = 0;
        let codHar = 0;

        verificandoToken();

        const token = localStorage.getItem('token');

        try {

            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satis/unica", {
                headers: {
                    Authorization: `${token}`
                }, params: {
                    satNum: satNum
                }
            });

            if (response.data.length > 0) {
                const row = response.data[0];
                codSis = row.CODSIS;
                setCodEqp(row.CODEQP ?? 0);
                codHar = row.CODEQP ?? 0;
                setTipoNome(row.tipo_nome ?? '');
                setTipoId(row.SATTIP != null ? Number(row.SATTIP) : null);
                setPrazoEmHoras(row.prazo_em_horas != null ? Number(row.prazo_em_horas) : null);
                setDataAberturaSati(row.SATDATSOL ?? null);
                const minutos = row.tempo_trabalhado_minutos != null ? Number(row.tempo_trabalhado_minutos) : 0;
                let aberto = row.em_periodo_aberto === true;

                if (!aberto && row.SATCOLABO != null && Number(row.SATCOLABO) === Number(localStorage.getItem('codUsu'))) {
                    const nomeSt = (getNomeStatus(row.SATSTASAI) || '').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                    if (nomeSt.includes('ATENDIMENTO') || nomeSt.includes('DESENVOLVIMENTO')) aberto = true;
                }
                setTempoTrabalhadoMinutos(minutos);
                setEmPeriodoAberto(aberto);
                const totalSegundos = minutos * 60;
                if (aberto) {
                    tempoTrabalhadoBaseRef.current = { baseMinutos: minutos, baseTimestamp: Date.now() };
                }
                setTempoTrabalhadoTexto(formatarTempoSegundos(totalSegundos));

                const statusSat = row.SATSTASAI != null ? row.SATSTASAI : null;
                setStatusAtual(statusSat);
                setAtendenteNome((row.atendente_nome ?? '').toString().trim());
                setSolicitanteNome((row.solicitante_nome ?? '').toString().trim());

                const minAnalise = row.tempo_analise_minutos != null ? Number(row.tempo_analise_minutos) : 0;
                setTempoAnaliseMinutos(minAnalise);

                const periodoAbertoAnalise = row.tempo_analise_periodo_aberto ?? null;
                let emAnaliseAgora = !!(periodoAbertoAnalise && typeof periodoAbertoAnalise === 'object');

                if (!emAnaliseAgora && statusSat != null) {
                    const nomeStatusAtual = (getNomeStatus(statusSat) || '')
                        .toUpperCase()
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '');
                    if (nomeStatusAtual.includes('ANALISE')) {
                        emAnaliseAgora = true;
                    }
                }

                if (emAnaliseAgora) {
                    setEmPeriodoAbertoAnalise(true);
                    tempoAnaliseBaseRef.current = { baseMinutos: minAnalise, baseTimestamp: Date.now() };
                    const totalSegundosAnalise = minAnalise * 60;
                    setTempoAnaliseTexto(formatarTempoSegundos(totalSegundosAnalise));
                } else {
                    setEmPeriodoAbertoAnalise(false);
                    const totalSegundosAnalise = minAnalise * 60;
                    setTempoAnaliseTexto(formatarTempoSegundos(totalSegundosAnalise));
                }

                const sid = row.sprint_id ?? row.SPRINT_ID ?? row.sprint?.id ?? row.sprint?.ID ?? null;
                const snome = (row.sprint_nome ?? row.SPRINT_NOME ?? row.sprint?.nome ?? row.sprint?.NOME ?? '').toString().trim() || '';
                const ehoras = row.estimativa_horas ?? row.ESTIMATIVA_HORAS;
                setSprintId(sid != null && sid !== '' && !Number.isNaN(Number(sid)) ? Number(sid) : null);
                setSprintNome(snome);
                setEstimativaHoras((ehoras != null && ehoras !== '' && !Number.isNaN(Number(ehoras))) ? Number(ehoras) : null);
                const usa = row.usa_sprint ?? row.USA_SPRINT;
                setUsaSprint(usa === 1 || usa === '1' || usa === true);

                const minTeste = row.tempo_teste_minutos != null ? Number(row.tempo_teste_minutos) : (row.TEMPO_TESTE_MINUTOS != null ? Number(row.TEMPO_TESTE_MINUTOS) : 0);
                setTempoTesteMinutos(minTeste);
                const periodoAbertoTeste = row.tempo_teste_periodo_aberto ?? row.TEMPO_TESTE_PERIODO_ABERTO ?? null;
                const emTesteAgora = !!(periodoAbertoTeste && typeof periodoAbertoTeste === 'object');
                if (emTesteAgora) {
                    setEmPeriodoAbertoTeste(true);
                    tempoTesteBaseRef.current = { baseMinutos: minTeste, baseTimestamp: Date.now() };
                    setTempoTesteTexto(formatarTempoSegundos(minTeste * 60));
                } else {
                    setEmPeriodoAbertoTeste(false);
                    setTempoTesteTexto(formatarTempoSegundos(minTeste * 60));
                }
                setDescricaoConsideracoesTeste((row.descricao_consideracoes_teste ?? row.DESCRICAO_CONSIDERACOES_TESTE ?? '').toString().trim() || '');
            }

        } catch (error) {
            return("");
        }

        if (codSis > 0) {
            try {

                const token = localStorage.getItem('token');

                const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/sistemas/espec", {
                    headers: {
                        Authorization: `${token}`
                    },
                    params: {
                        codSis: codSis
                    }
                });

                if (response.data.length > 0) {
                    setNomSis(response.data[0].nomsis);
                } else {
                    setNomSis("");
                }

            } catch (error) {
                console.error('Erro ao buscar dados:', error);
            }
        }

        if (codHar > 0) {
            try {
                verificandoToken();

                const token = localStorage.getItem('token');
                const ipBackend = localStorage.getItem('ipBackend2');

                if (!token || !ipBackend) {
                    console.warn('Token ou IP do backend ausente');
                    return "";
                }

                const response = await axios.get(ensureProtocol(ipBackend) + '/hardware/espec', {
                    headers: {
                        Authorization: token
                    },
                    params: { codHar }
                });

                const data = response.data;

                if (Array.isArray(data) && data.length > 0) {
                    const { NOMEQP, sereqp, pateqp } = data[0];
                    setNomEqp(`${NOMEQP} - ${sereqp} - ${pateqp}`);
                } else {
                    console.warn('Nenhum equipamento encontrado.');
                    setNomEqp("");
                }

            } catch (error) {
                console.error('Erro ao buscar equipamento:', error.message || error);
            }
        }

        fetchColaboradores();
    }

    const sadDesSolGet = async () => {

        satNum = props.match.params.id;

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satis/unica", {
                headers: {
                    Authorization: `${token}`
                }, params: {
                    satNum: satNum
                }
            });

            if (response.data[0].SATNUM > 0) {
                const r = response.data[0];
                setSatDesSol(r.SATDESSOL);
                setSatAntSol(r.SATDESSOL);
                const descAnalise = r.descricao_analise_requisitos ?? r.DESCRICAO_ANALISE_REQUISITOS ?? '';
                setDescricaoAnaliseRequisitos(descAnalise || '');
                const descTeste = r.descricao_consideracoes_teste ?? r.DESCRICAO_CONSIDERACOES_TESTE ?? '';
                setDescricaoConsideracoesTeste((descTeste || '').toString().trim());
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }

    }

    const updateSatiHistorico = async (e) => {

        e.preventDefault();

        satNum = props.match.params.id;

        verificandoToken();

        const token = localStorage.getItem('token');

        let desSli = satDesHis;

        if (desSli.trim().length > 0) {
            try {
                await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satis",
                    {
                        satNum,
                        desSli,
                        interno: comentarioInterno,
                        enviarEmail: marcado && !comentarioInterno,
                    },
                    {
                        headers: {
                            Authorization: `${token}`
                        }
                    });

                setSatDesHis('');
                fetchData();

            } catch (error) {
                console.error('Erro ao inserir dados:', error);
            }
        } else {
            setModalAlert({ show: true, title: 'Atenção', message: 'Favor preencher o trâmite!' });
        }

    }

    const updateDescricao = async (e) => {

        verificandoToken();

        const token = localStorage.getItem('token');

        if (satAntSol !== satDesSol) {

            e.preventDefault();

            satNum = props.match.params.id;

            let desSol = satDesSol;

            if (desSol.trim().length > 0) {
                try {
                    const response = await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satis/editDescr",
                        {
                            satNum, desSol, satAntSol
                        },
                        {
                            headers: {
                                Authorization: `${token}`
                            }
                        });

                    sadDesSolGet();
                    fetchData();

                } catch (error) {
                    console.error('Erro ao inserir dados:', error);
                }
            } else {
                setModalAlert({ show: true, title: 'Atenção', message: 'Favor preencher a descrição do chamado!' });
            }
        }
    }

    const MENSAGEM_FECHAMENTO_SUGERIDA = "Chamado finalizado com sucesso. Solicitante atendido e solução aplicada. Obrigado por utilizar o sistema TACOMA.";

    const salvarAnaliseRequisitos = async () => {
        verificandoToken();
        const token = localStorage.getItem('token');
        const id = props.match.params.id;
        if (!id) return;
        setSalvandoAnalise(true);
        try {
            await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satis/analise-requisitos",
                {
                    satNum: id,
                    descricao: descricaoAnaliseRequisitos || ''
                },
                {
                    headers: {
                        Authorization: `${token}`
                    }
                });
        } catch (error) {
            console.error('Erro ao salvar análise de requisitos:', error);
            setModalAlert({ show: true, title: 'Erro', message: 'Erro ao salvar a análise de requisitos. Tente novamente.' });
        } finally {
            setSalvandoAnalise(false);
        }
    };

    const salvarConsideracoesTeste = async () => {
        verificandoToken();
        const token = localStorage.getItem('token');
        const id = props.match.params.id;
        if (!id) return;
        setSalvandoConsideracoesTeste(true);
        try {
            await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satis/consideracoes-teste",
                { satNum: id, descricao: descricaoConsideracoesTeste || '' },
                { headers: { Authorization: token } });
        } catch (error) {
            console.error('Erro ao salvar considerações de teste:', error);
            setModalAlert({ show: true, title: 'Erro', message: 'Erro ao salvar. Tente novamente.' });
        } finally {
            setSalvandoConsideracoesTeste(false);
        }
    };

    const concluindoSATI = async () => {
        satNum = props.match.params.id;
        let desSli = (satDesHis || '').trim();

        if (desSli.length === 0) {
            setSatDesHis(MENSAGEM_FECHAMENTO_SUGERIDA);
            setModalAlert({ show: true, title: 'Atenção', message: 'Nenhum trâmite foi inserido. Foi sugerida uma mensagem de fechamento no campo "Inserir Trâmite". Você pode editá-la se quiser e clicar em "Concluir Chamado" novamente.' });
            return;
        }

        confirmCallbackRef.current = () => {
            concluindoSATIConfirmado();
        };
        setModalConfirm({ show: true, title: 'Concluir chamado', message: 'Você realmente deseja concluir o chamado?' });
    };

    const concluindoSATIConfirmado = async () => {
        let codUsu = localStorage.getItem('codUsu');
        satNum = props.match.params.id;
        let desSli = (satDesHis || '').trim();
        if (desSli.length === 0) return;

        desSli = desSli.endsWith("TACOMA.") || desSli.endsWith("TACOMA!") ? desSli : desSli + " — TACOMA";

        verificandoToken();
        const token = localStorage.getItem('token');

        try {
            await axios.put(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satis/concluir",
                {
                    satNum, desSli, codUsu
                },
                {
                    headers: {
                        Authorization: `${token}`
                    }
                });

            setSatDesHis('');
            fetchData();
            setSucesso('S');

            if (codEqp !== "0") {
                verificandoToken();
                const tokenEqp = localStorage.getItem('token');
                try {
                    await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hishardware",
                        { codHar: codEqp, desHis: `Fechamento de chamado - ${satNum} \n\n ${desSli}` },
                        { headers: { Authorization: `${tokenEqp}` } });
                } catch (error) {
                    setSucesso('N');
                }
            }
        } catch (error) {
            console.error('Erro ao inserir dados:', error);
        }
    }

    const baseUrlAnalista = () => localStorage.getItem('ipBackend2') ? ensureProtocol(localStorage.getItem('ipBackend2')) : '';

    const alterarStatusChamado = async (novoStatus) => {
        const id = props.match.params.id;
        if (!id) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.put(baseUrlAnalista() + '/satis/status',
                { satStaSai: Number(novoStatus), old: statusAtual, satNum: id },
                { headers: { Authorization: token } }
            );
            await retornarSistema(id);
            fetchData();
        } catch (err) {
            console.error('Erro ao alterar status:', err);
        }
    };

    const handlePegarChamado = async () => {
        const id = props.match.params.id;
        const colabo = localStorage.getItem('codUsu');
        if (!id || !colabo) return;
        const contexto = abaAtiva === 'ANALISE' ? 'analise'
            : abaAtiva === 'TESTE' ? 'teste'
            : (usaSprint ? 'desenvolvimento' : 'atendimento');
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.put(baseUrlAnalista() + '/satis/pegar', { colabo, satNum: id, contexto }, { headers: { Authorization: token } });

            if (contexto === 'analise') {
                setEmPeriodoAberto(false);
                setEmPeriodoAbertoTeste(false);
                tempoAnaliseBaseRef.current = { baseMinutos: tempoAnaliseMinutos, baseTimestamp: Date.now() };
                setTempoAnaliseTexto(formatarTempoSegundos(tempoAnaliseMinutos * 60));
                setEmPeriodoAbertoAnalise(true);
            } else if (contexto === 'teste') {
                setEmPeriodoAberto(false);
                setEmPeriodoAbertoAnalise(false);
                tempoTesteBaseRef.current = { baseMinutos: tempoTesteMinutos, baseTimestamp: Date.now() };
                setTempoTesteTexto(formatarTempoSegundos(tempoTesteMinutos * 60));
                setEmPeriodoAbertoTeste(true);
            } else {
                setEmPeriodoAbertoAnalise(false);
                setEmPeriodoAbertoTeste(false);
                tempoTrabalhadoBaseRef.current = { baseMinutos: tempoTrabalhadoMinutos, baseTimestamp: Date.now() };
                setTempoTrabalhadoTexto(formatarTempoSegundos(tempoTrabalhadoMinutos * 60));
                setEmPeriodoAberto(true);
            }

            await retornarSistema(id);
            fetchData();
        } catch (err) {
            console.error('Erro ao pegar chamado:', err);
        }
    };

    const handlePausarChamado = async () => {
        const id = props.match.params.id;
        if (!id) return;
        const contexto = abaAtiva === 'ANALISE' ? 'analise'
            : abaAtiva === 'TESTE' ? 'teste'
            : (usaSprint ? 'desenvolvimento' : 'atendimento');

        if (contexto === 'analise') setEmPeriodoAbertoAnalise(false);
        else if (contexto === 'teste') setEmPeriodoAbertoTeste(false);
        else setEmPeriodoAberto(false);
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.put(baseUrlAnalista() + '/satis/pausar', { satNum: id, contexto }, { headers: { Authorization: token } });
            await retornarSistema(id);
            fetchData();
        } catch (err) {
            console.error('Erro ao pausar chamado:', err);
        }
    };

    const handleAdicionarColaborador = async () => {
        const id = props.match.params.id;
        const baseUrl = baseUrlAnalista();
        const usuarioId = (novoColaboradorId || '').trim();
        if (!id || !baseUrl || !usuarioId) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        setSalvandoColaborador(true);
        try {
            await axios.post(
                baseUrl + `/satis/${id}/colaboradores`,
                { usuarioId: Number(usuarioId) },
                { headers: { Authorization: `${token}` } }
            );
            setNovoColaboradorId('');
            await fetchColaboradores();
        } catch (err) {
            console.error('Erro ao adicionar colaborador:', err);
            const msg = err.response?.data?.error || 'Erro ao adicionar colaborador.';
            setModalAlert({ show: true, title: 'Erro', message: msg });
        } finally {
            setSalvandoColaborador(false);
        }
    };

    const handleRemoverColaborador = (usuarioId) => {
        const id = props.match.params.id;
        const baseUrl = baseUrlAnalista();
        if (!id || !baseUrl || !usuarioId) return;
        confirmCallbackRef.current = async () => {
            verificandoToken();
            const token = localStorage.getItem('token');
            setSalvandoColaborador(true);
            try {
                await axios.delete(
                    baseUrl + `/satis/${id}/colaboradores/${usuarioId}`,
                    { headers: { Authorization: `${token}` } }
                );
                await fetchColaboradores();
            } catch (err) {
                console.error('Erro ao remover colaborador:', err);
                const msg = err.response?.data?.error || 'Erro ao remover colaborador.';
                setModalAlert({ show: true, title: 'Erro', message: msg });
            } finally {
                setSalvandoColaborador(false);
            }
        };
        setModalConfirm({ show: true, title: 'Remover colaborador', message: 'Remover este colaborador do chamado?' });
    };

    const handleAtribuirAtendente = async (usuSeq, nomAte) => {
        const id = props.match.params.id;
        const baseUrl = baseUrlAnalista();
        if (!id || !baseUrl || !usuSeq) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        setSalvandoAtribuicaoAtendente(true);
        try {
            await axios.put(baseUrl + '/satis/atendente', {
                satNum: id,
                usuSeq: Number(usuSeq),
                nomAte: (nomAte || '').toString().trim() || undefined,
            }, { headers: { Authorization: `${token}` } });
            setNovoResponsavelId('');
            await retornarSistema(id);
            fetchData();
        } catch (err) {
            console.error('Erro ao atribuir atendente:', err);
            setModalAlert({ show: true, title: 'Erro', message: err.response?.data?.error || 'Erro ao atribuir responsável. Tente novamente.' });
        } finally {
            setSalvandoAtribuicaoAtendente(false);
        }
    };

    const deleteHistoricoChamado = (codHis) => {
        confirmCallbackRef.current = async () => {
            verificandoToken();
            const token = localStorage.getItem('token');
            try {
                await axios.delete(ensureProtocol(localStorage.getItem('ipBackend2')) + '/satHis', {
                    headers: { Authorization: `${token}` },
                    data: { codHis },
                });
                await fetchData();
            } catch (err) {
                console.error('Erro ao excluir histórico:', err);
            }
        };
        setModalConfirm({ show: true, title: 'Excluir documento', message: 'Você realmente deseja excluir o documento ' + codHis + '?' });
    };

    const buscarSugestaoSolucao = async () => {
        const desc = (satDesSol || '').trim();
        if (desc.length < 3) {
            setSugestaoSolucaoMensagem('A descrição do chamado precisa ter ao menos 3 caracteres para buscar soluções similares.');
            setSugestaoSolucao('');
            setChamadosRelacionados([]);
            return;
        }
        setSugestaoSolucaoMensagem('');
        setSugestaoSolucaoLoading(true);
        setSugestaoSolucao('');
        setChamadosRelacionados([]);
        const url = baseUrlAnalista();
        if (!url) {
            setSugestaoSolucaoLoading(false);
            return;
        }
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const tramites = (data || []).map((t) => t.descricao || t.SATDESSLI || '').filter(Boolean);
            const response = await axios.post(url + '/satis/sugestao-solucao', { descricao: desc, tramites }, { headers: { Authorization: token } });
            setSugestaoSolucao(response.data?.sugestao ?? '');
            setChamadosRelacionados(Array.isArray(response.data?.chamadosRelacionados) ? response.data.chamadosRelacionados : []);
            if (response.data?.mensagem) setSugestaoSolucaoMensagem(response.data.mensagem);
        } catch (err) {
            console.error('Erro ao buscar sugestão de solução:', err);
            setSugestaoSolucao('');
            setSugestaoSolucaoMensagem(err.response?.data?.error || 'Erro ao buscar sugestão. Tente novamente.');
        } finally {
            setSugestaoSolucaoLoading(false);
        }
    };

    const reverResposta = async () => {
        const texto = (satDesHis || '').trim();
        if (texto.length < 2) {
            setModalAlert({ show: true, title: 'Atenção', message: 'Digite ao menos um pouco do trâmite ou mensagem de fechamento para a IA sugerir uma revisão.' });
            return;
        }
        setReverRespostaLoading(true);
        const url = baseUrlAnalista();
        if (!url) {
            setReverRespostaLoading(false);
            return;
        }
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.post(url + '/satis/rever-resposta', { texto }, { headers: { Authorization: token } });
            const sugestao = response.data?.sugestao;
            const revisado = response.data?.revisado === true;
            const origem = response.data?.origem || 'ia';
            if (revisado && typeof sugestao === 'string' && sugestao.trim()) {
                setSatDesHis(sugestao.trim());
                if (origem === 'fallback') setModalAlert({ show: true, title: 'Aviso', message: 'Revisão aplicada com texto padrão (a IA não retornou resposta).' });
            } else {
                setModalAlert({ show: true, title: 'Aviso', message: 'A IA não sugeriu alterações para este texto. Tente reformular ou escrever um pouco mais.' });
            }
        } catch (err) {
            console.error('Erro ao rever resposta:', err);
            setModalAlert({ show: true, title: 'Erro', message: err.response?.data?.error || 'Erro ao revisar texto. Tente novamente.' });
        } finally {
            setReverRespostaLoading(false);
        }
    };

    const buscarResumo = async () => {
        const url = baseUrlAnalista();
        if (!url) return;
        setResumoLoading(true);
        setResumoChamado('');
        verificandoToken();
        const token = localStorage.getItem('token');
        const tramites = (data || []).map((t) => t.descricao || t.SATDESSLI || '');
        try {
            const response = await axios.post(url + '/satis/resumo-chamado', { descricao: (satDesSol || '').trim(), tramites }, { headers: { Authorization: token } });
            const texto = response.data?.resumo || '';
            setResumoChamado(texto);
            setResumoOrigem(response.data?.origem || 'ia');
            return texto;
        } catch (err) {
            console.error('Erro ao buscar resumo:', err);
            setResumoChamado('');
            return '';
        } finally {
            setResumoLoading(false);
        }
    };

    const abrirResumoParaImpressao = async () => {
        let texto = resumoChamado || '';
        if (!texto.trim()) {
            if ((satDesSol || '').trim().length < 2) {
                setModalAlert({ show: true, title: 'Atenção', message: 'A descrição do chamado é necessária para gerar o resumo. Preencha e tente novamente.' });
                return;
            }
            texto = await buscarResumo();
        }
        if (!texto.trim()) {
            setModalAlert({ show: true, title: 'Aviso', message: 'Não foi possível gerar o resumo. Tente novamente.' });
            return;
        }
        const titulo = `Chamado #${satNum}${nomSis ? ' - ' + nomSis : ''}`;
        const janela = window.open('', '_blank', 'width=700,height=500,scrollbars=yes');
        if (!janela) {
            setModalAlert({ show: true, title: 'Atenção', message: 'Permita pop-ups para abrir a tela de impressão.' });
            return;
        }
        janela.document.write(`
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Resumo - Chamado ${satNum}</title>
  <style>
    body { font-family: Arial, sans-serif; margin: 24px; max-width: 650px; }
    h1 { font-size: 1.25rem; color: #0d6efd; margin-bottom: 8px; }
    .resumo { white-space: pre-wrap; line-height: 1.5; margin: 16px 0; }
    .meta { font-size: 0.875rem; color: #6c757d; margin-top: 16px; }
    @media print { body { margin: 16px; } .no-print { display: none; } }
  </style>
</head>
<body>
  <h1>${titulo}</h1>
  <p class="meta">Resumo gerado por IA</p>
  <div class="resumo">${texto.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>
  <p class="meta">Imprima esta página (Ctrl+P) ou feche quando terminar.</p>
  <button class="no-print" onclick="window.print()" style="margin-top:12px;padding:8px 16px;cursor:pointer;">Imprimir</button>
  <button class="no-print" onclick="window.close()" style="margin-top:12px;margin-left:8px;padding:8px 16px;cursor:pointer;">Fechar</button>
</body>
</html>`);
        janela.document.close();
    };

    const buscarSugestaoPrioridade = async () => {
        const url = baseUrlAnalista();
        if (!url) return;
        setPrioridadeLoading(true);
        setPrioridadeSugerida(null);
        setOrdensPrioridade([]);
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const response = await axios.post(url + '/satis/sugestao-prioridade', { descricao: (satDesSol || '').trim(), tipo: tipoNome }, { headers: { Authorization: token } });
            setPrioridadeSugerida(response.data?.prioridadeSugerida != null ? response.data.prioridadeSugerida : null);
            setOrdensPrioridade(Array.isArray(response.data?.ordens) ? response.data.ordens : []);
            setOrdensComNome(Array.isArray(response.data?.ordensComNome) ? response.data.ordensComNome : []);
            setNomeSugeridoPrioridade(typeof response.data?.nomeSugerido === 'string' ? response.data.nomeSugerido : '');
        } catch (err) {
            console.error('Erro ao sugerir prioridade:', err);
        } finally {
            setPrioridadeLoading(false);
        }
    };

    const openModalTipo = () => {
        setTipoIdAtual(tipoId != null ? String(tipoId) : '');
        setShowModalTipo(true);
    };

    const salvarTipoChamado = async () => {
        const url = baseUrlAnalista();
        if (!url || !satNum) return;
        const novoTipo = tipoIdAtual.trim() ? Number(tipoIdAtual) : null;
        if (novoTipo == null || Number.isNaN(novoTipo)) {
            setModalAlert({ show: true, title: 'Aviso', message: 'Selecione um tipo.' });
            return;
        }
        setSalvandoTipo(true);
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.put(url + '/satis/tipoSati', { satTip: novoTipo, satNum }, { headers: { Authorization: token } });
            setShowModalTipo(false);
            await retornarSistema(satNum);
        } catch (err) {
            console.error('Erro ao alterar tipo:', err);
            setModalAlert({ show: true, title: 'Erro', message: err.response?.data?.error || 'Não foi possível alterar o tipo. Tente novamente.' });
        } finally {
            setSalvandoTipo(false);
        }
    };

    const buscarSugestaoResposta = async () => {
        const url = baseUrlAnalista();
        if (!url) return;
        setSugestaoRespostaLoading(true);
        setSugestaoResposta('');
        verificandoToken();
        const token = localStorage.getItem('token');

        const textoRascunho = (satDesHis || '').trim();
        const ultimoTramiteSalvo = (data && data[0]) ? (data[0].descricao || data[0].SATDESSLI || '') : '';
        const ultimoTramite = textoRascunho.length > 0 ? textoRascunho : ultimoTramiteSalvo;
        try {
            const response = await axios.post(url + '/satis/sugestao-resposta', { descricao: (satDesSol || '').trim(), ultimoTramite }, { headers: { Authorization: token } });
            const sug = response.data?.sugestao || '';
            const origem = response.data?.origem || 'ia';
            if (sug) setSatDesHis(sug);
            if (origem === 'fallback') setModalAlert({ show: true, title: 'Aviso', message: 'Sugestão padrão exibida (a IA não retornou resposta).' });
        } catch (err) {
            console.error('Erro ao sugerir resposta:', err);
        } finally {
            setSugestaoRespostaLoading(false);
        }
    };

    const sugerirProximosPassos = async () => {
        const url = baseUrlAnalista();
        const id = props.match.params.id;
        if (!url || !id) return;
        setProximosPassosLoading(true);
        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            const tramites = (data || []).map((t) => t.descricao || t.SATDESSLI || '').filter(Boolean);
            const response = await axios.post(url + '/satis/proximos-passos', { descricao: (satDesSol || '').trim(), satNum: parseInt(id, 10), tramites }, { headers: { Authorization: token } });
            if (response.data?.ok) {
                fetchData();
                const origem = response.data?.origem || 'ia';
                const msgFallback = origem === 'fallback' ? ' (Sugestão padrão — a IA não retornou resposta.)' : '';
                if (response.data?.gravado) setModalAlert({ show: true, title: 'Sucesso', message: 'Próximos passos gravados como comentário interno.' + msgFallback });
                else if (response.data?.mensagem) setModalAlert({ show: true, title: 'Aviso', message: response.data.mensagem + msgFallback });
            } else {
                setModalAlert({ show: true, title: 'Aviso', message: response.data?.mensagem || 'Não foi possível gerar próximos passos.' });
            }
        } catch (err) {
            console.error('Erro ao sugerir próximos passos:', err);
            setModalAlert({ show: true, title: 'Erro', message: err.response?.data?.error || 'Erro ao sugerir próximos passos.' });
        } finally {
            setProximosPassosLoading(false);
        }
    };

    useEffect(() => {
        verificar();
        setSatNum(props.match.params.id);
        retornarSistema(props.match.params.id);
        fetchData();
        sadDesSolGet();
        fetchAnexos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const id = props.match.params.id;
        if (!id) return;
        verificandoToken();
        const token = localStorage.getItem('token');
        axios.get(ensureProtocol(localStorage.getItem('ipBackend2')) + '/satis/unica', {
            headers: { Authorization: token },
            params: { satNum: id }
        }).then((res) => {
            const data = Array.isArray(res.data) ? res.data : [];
            if (data.length === 0) return;
            const r = data[0];
            const sid = r.sprint_id ?? r.SPRINT_ID ?? r.sprint?.id ?? r.sprint?.ID ?? null;
            const snome = (r.sprint_nome ?? r.SPRINT_NOME ?? r.sprint?.nome ?? r.sprint?.NOME ?? '').toString().trim() || '';
            const ehoras = r.estimativa_horas ?? r.ESTIMATIVA_HORAS;
            const usa = r.usa_sprint ?? r.USA_SPRINT;
            setSprintId(sid != null && sid !== '' && !Number.isNaN(Number(sid)) ? Number(sid) : null);
            setSprintNome(snome);
            setEstimativaHoras((ehoras != null && ehoras !== '' && !Number.isNaN(Number(ehoras))) ? Number(ehoras) : null);
            setUsaSprint(usa === 1 || usa === '1' || usa === true);
            const minTeste = r.tempo_teste_minutos != null ? Number(r.tempo_teste_minutos) : (r.TEMPO_TESTE_MINUTOS != null ? Number(r.TEMPO_TESTE_MINUTOS) : 0);
            setTempoTesteMinutos(minTeste);
            const periodoTeste = r.tempo_teste_periodo_aberto ?? r.TEMPO_TESTE_PERIODO_ABERTO ?? null;
            const emTeste = !!(periodoTeste && typeof periodoTeste === 'object');
            setEmPeriodoAbertoTeste(emTeste);
            if (emTeste) tempoTesteBaseRef.current = { baseMinutos: minTeste, baseTimestamp: Date.now() };
            setTempoTesteTexto(formatarTempoSegundos(minTeste * 60));
            setDescricaoConsideracoesTeste((r.descricao_consideracoes_teste ?? r.DESCRICAO_CONSIDERACOES_TESTE ?? '').toString().trim() || '');
        }).catch(() => {});
    }, [props.match.params.id]);

    const prioridadeBadge = prioridadeSugerida != null
        ? (nomeSugeridoPrioridade ? `P${prioridadeSugerida} (${nomeSugeridoPrioridade})` : `P${prioridadeSugerida}`)
        : null;

    const resumoActionsRight = iaHabilitada ? (
        <div className="chamado-header-resumo-btns">
            <button type="button" className="btn btn-ia btn-sm" onClick={buscarResumo} disabled={resumoLoading} title="Gerar resumo com IA">
                {resumoLoading ? 'Gerando...' : 'Gerar resumo do chamado (IA)'}
            </button>
            <button type="button" className="btn btn-outline-secondary btn-sm" onClick={abrirResumoParaImpressao} disabled={resumoLoading} title="Abrir resumo para impressão">
                <i className="fas fa-print me-1" aria-hidden="true" /> Abrir para impressão
            </button>
        </div>
    ) : null;

    const resumoIABar = iaHabilitada && (resumoChamado || resumoLoading) ? (
        <div className="historico-sati-resumo-bar card border-info sugestao-ia-card">
            <div className="card-body py-2 d-flex justify-content-between align-items-start gap-2 flex-wrap">
                <div className="flex-grow-1">
                    <strong className="text-info">Resumo do chamado ({resumoOrigem === 'fallback' ? 'padrão — IA não respondeu' : 'gerado por IA'})</strong>
                    <p className="mb-0 mt-1 texto-sugestao-ia">{resumoLoading ? 'Gerando resumo...' : resumoChamado}</p>
                </div>
                <div className="d-flex gap-2 align-items-center">
                    <button type="button" className="btn btn-ia btn-sm" onClick={buscarResumo} disabled={resumoLoading} title="Atualizar resumo com IA">Atualizar</button>
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={abrirResumoParaImpressao} disabled={resumoLoading} title="Abrir em nova janela para impressão"><i className="fas fa-print me-1" aria-hidden="true"></i>Abrir para impressão</button>
                    <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setResumoChamado('')} disabled={resumoLoading} title="Fechar resumo"><i className="fas fa-times me-1" aria-hidden="true"></i>Fechar</button>
                </div>
            </div>
        </div>
    ) : null;

    const baseUrlAnexos = localStorage.getItem('ipBackend2') ? ensureProtocol(localStorage.getItem('ipBackend2')) + '/anexos/download' : null;
    const anexosCardContent = (
        <>
            <h4 className="chamado-sidebar-card-titulo">
                <i className="fas fa-paperclip me-2" aria-hidden="true" />
                Anexos {anexos.length > 0 && `(${anexos.length})`}
            </h4>
            {anexos.length === 0 ? (
                <p className="chamado-sidebar-anexos-vazio">Sem anexos para o chamado.</p>
            ) : (
                <div className="chamado-sidebar-anexos-lista">
                    <ListaAnexos
                            arrayAnexos={anexos}
                            satNum={props.match.params.id}
                            baseUrlDownload={baseUrlAnexos}
                            nomeClicavel
                            onDelete={excluirAnexoNoCard}
                            compact
                        />
                </div>
            )}
            <div className="chamado-sidebar-anexos-adicionar">
                <ChamadoAttachmentField
                    id="historico-sati-anexo-field"
                    nomeArquivo={novoAnexoNome}
                    onFileChange={({ base64, nome }) => { setNovoAnexoBase64(base64 || ''); setNovoAnexoNome(nome || ''); }}
                />
                <label className="chamado-anexos-interno">
                    <input type="checkbox" checked={novoAnexoInterno} onChange={(e) => setNovoAnexoInterno(e.target.checked)} />
                    <span>Anexo interno</span>
                </label>
                <button type="button" className="btn btn-primary btn-sm" onClick={adicionarAnexoNoCard} disabled={salvandoAnexo || !novoAnexoBase64 || !novoAnexoNome?.trim()}>
                    {salvandoAnexo ? 'Enviando...' : 'Adicionar anexo'}
                </button>
            </div>
        </>
    );

    const descriptionContent = (
        <>
            {abaAtiva === 'DESENVOLVIMENTO' && satNum > 0 && (
                <DesenvolvimentoCard satNum={satNum} embedded />
            )}
            {abaAtiva === 'HORAS' && satNum > 0 && (
                <ApontamentosCard
                    satNum={satNum}
                    embedded
                    usaSprint={usaSprint}
                    tempoOperacional={{
                        atendimento: usaSprint ? 0 : tempoTrabalhadoMinutos,
                        desenvolvimento: usaSprint ? tempoTrabalhadoMinutos : 0,
                        analise: tempoAnaliseMinutos,
                        teste: tempoTesteMinutos,
                    }}
                />
            )}
            {abaAtiva === 'ATENDIMENTO' && (
                <>
                    <textarea ref={descricaoTextareaRef} value={satDesSol} onChange={(e) => { setSatDesSol(e.target.value); setTimeout(ajustarAlturaDescricao, 0); }} onInput={() => setTimeout(ajustarAlturaDescricao, 0)} className="form-control historico-sati-textarea-grande" id="textarea-descricao-chamado" rows={2} placeholder="Descrição do chamado..." />
                    {iaHabilitada && (
                        <div className="historico-sati-acoes-aba">
                            <button type="button" className="btn btn-ia btn-sm" onClick={buscarSugestaoSolucao} disabled={sugestaoSolucaoLoading} title="Busca chamados fechados com descrição parecida e sugere solução com base na IA">{sugestaoSolucaoLoading ? 'Buscando...' : 'Buscar solução em chamados fechados'}</button>
                            <small className="text-muted">Sugestão com base em chamados já atendidos</small>
                        </div>
                    )}
                    {iaHabilitada && sugestaoSolucaoMensagem && <p className="text-muted small mt-1 mb-0">{sugestaoSolucaoMensagem}</p>}
                    {iaHabilitada && sugestaoSolucao && (
                        <div className="card mt-2 border-info sugestao-ia-card">
                            <div className="card-body py-2">
                                <strong className="text-info">Sugestão:</strong>
                                <p className="mb-0 mt-1 texto-sugestao-ia">{sugestaoSolucao}</p>
                                {chamadosRelacionados.length > 0 && <small className="text-muted d-block mt-1">Chamados parecidos: #{chamadosRelacionados.map((c) => c.satNum).join(', #')}</small>}
                            </div>
                        </div>
                    )}
                    <div className="historico-sati-acoes-aba">
                        <button onClick={updateDescricao} className="btn btn-secondary btn-sm" type="button"><i className="fas fa-save me-1" aria-hidden="true"></i> Alterar descrição do chamado</button>
                    </div>
                </>
            )}
            {abaAtiva === 'ANALISE' && (
                <>
                    <label htmlFor="textarea-analise-requisitos" className="form-label">Descrição da análise de requisitos</label>
                    <textarea id="textarea-analise-requisitos" ref={analiseTextareaRef} className="form-control historico-sati-textarea-grande historico-sati-textarea-analise" rows={2} value={descricaoAnaliseRequisitos} onChange={(e) => { setDescricaoAnaliseRequisitos(e.target.value); setTimeout(ajustarAlturaAnalise, 0); }} onInput={() => setTimeout(ajustarAlturaAnalise, 0)} placeholder="Explique aqui a análise de requisitos realizada, escopo definido, impactos, validações, etc." />
                    <div className="historico-sati-acoes-aba">
                        <button type="button" className="btn btn-secondary btn-sm" onClick={salvarAnaliseRequisitos} disabled={salvandoAnalise}>{salvandoAnalise ? 'Salvando...' : 'Salvar análise de requisitos'}</button>
                    </div>
                </>
            )}
            {abaAtiva === 'TESTE' && (
                <>
                    <label htmlFor="textarea-consideracoes-teste" className="form-label">Considerações de teste</label>
                    <textarea id="textarea-consideracoes-teste" ref={testeTextareaRef} className="form-control historico-sati-textarea-grande historico-sati-textarea-analise" rows={2} value={descricaoConsideracoesTeste} onChange={(e) => { setDescricaoConsideracoesTeste(e.target.value); setTimeout(ajustarAlturaTeste, 0); }} onInput={() => setTimeout(ajustarAlturaTeste, 0)} placeholder="Registre aqui as considerações de teste: cenários testados, resultados, pendências, etc." />
                    <div className="historico-sati-acoes-aba">
                        <button type="button" className="btn btn-secondary btn-sm" onClick={salvarConsideracoesTeste} disabled={salvandoConsideracoesTeste}>{salvandoConsideracoesTeste ? 'Salvando...' : 'Salvar considerações de teste'}</button>
                    </div>
                </>
            )}
        </>
    );

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <ModalAlert
                open={modalAlert.show}
                onClose={() => setModalAlert({ show: false, title: 'Aviso', message: '' })}
                title={modalAlert.title}
                message={modalAlert.message}
                labelOk="OK"
            />
            <ModalConfirm
                open={modalConfirm.show}
                onClose={() => setModalConfirm({ show: false, title: '', message: '' })}
                title={modalConfirm.title}
                message={modalConfirm.message}
                confirmLabel="Sim"
                cancelLabel="Cancelar"
                onConfirm={() => { if (confirmCallbackRef.current) confirmCallbackRef.current(); }}
                variant="primary"
            />
            {showModalTipo && (
                <div className="modal show d-block" style={{ background: 'rgba(0,0,0,0.5)' }} tabIndex={-1} role="dialog" aria-label="Alterar tipo do chamado">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Alterar tipo do chamado</h5>
                                <button type="button" className="btn-close" onClick={() => setShowModalTipo(false)} aria-label="Fechar" />
                            </div>
                            <div className="modal-body">
                                <label htmlFor="historico-sati-select-tipo" className="form-label">Tipo</label>
                                <select id="historico-sati-select-tipo" className="form-select" value={tipoIdAtual} onChange={(e) => setTipoIdAtual(e.target.value)}>
                                    <option value="">Selecione...</option>
                                    {(Array.isArray(tiposChamado) ? tiposChamado : []).filter((t) => t.ativo !== 0).map((t) => (
                                        <option key={t.id} value={String(t.id)}>{t.nome || 'Tipo ' + t.id}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowModalTipo(false)}>Cancelar</button>
                                <button type="button" className="btn btn-primary" onClick={salvarTipoChamado} disabled={salvandoTipo}>{salvandoTipo ? 'Salvando...' : 'Salvar'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {sucesso === 'S' ? <Redirect to='/home' /> : null}
            <ChamadoPage
                satNum={satNum}
                titulo={`Chamado #${satNum}`}
                subtitulo={nomSis.trim() ? nomSis : null}
                solicitanteNome={solicitanteNome}
                atendenteNome={atendenteNome}
                statusAtual={statusAtual}
                statusParaSelect={statusParaSelect}
                getNomeStatus={getNomeStatus}
                onStatusChange={alterarStatusChamado}
                prioridadeBadge={prioridadeBadge}
                sprintId={sprintId}
                sprintNome={sprintNome}
                tipoNome={tipoNome}
                abaAtiva={abaAtiva}
                onAbaChange={setAbaAtiva}
                descriptionContent={descriptionContent}
                editorProps={{
                    value: satDesHis,
                    onChange: setSatDesHis,
                    onInserir: updateSatiHistorico,
                    onAnexar: openAnexo,
                    marcado,
                    onMarcadoChange: setMarcado,
                    comentarioInterno,
                    onComentarioInternoChange: setComentarioInterno,
                    iaHabilitada,
                    onSugerirResposta: buscarSugestaoResposta,
                    onReverResposta: reverResposta,
                    onSugerirProximosPassos: sugerirProximosPassos,
                    sugestaoRespostaLoading,
                    reverRespostaLoading,
                    proximosPassosLoading,
                    onAtualizar: fetchData,
                }}
                timelineEventos={data}
                onDeleteHistorico={deleteHistoricoChamado}
                sidebarProps={{
                    atendenteNome,
                    statusAtual,
                    statusParaSelect,
                    getNomeStatus,
                    onStatusChange: alterarStatusChamado,
                    sprintId,
                    sprintNome,
                    estimativaHoras,
                    tempoTrabalhadoTexto,
                    tempoAnaliseTexto,
                    tempoTesteTexto,
                    emPeriodoAberto,
                    emPeriodoAbertoAnalise,
                    emPeriodoAbertoTeste,
                    tempoTrabalhadoMinutos,
                    usaSprint,
                    colaboradores,
                    carregandoColaboradores,
                    opcoesColaboradores,
                    novoColaboradorId,
                    onNovoColaboradorChange: setNovoColaboradorId,
                    onAdicionarColaborador: handleAdicionarColaborador,
                    onRemoverColaborador: handleRemoverColaborador,
                    salvandoColaborador,
                    carregandoOpcoesColaboradores,
                    novoResponsavelId,
                    onNovoResponsavelChange: setNovoResponsavelId,
                    onAtribuirAtendente: handleAtribuirAtendente,
                    salvandoAtribuicaoAtendente,
                    onIniciarAtendimento: handlePegarChamado,
                    onPausar: handlePausarChamado,
                    onConcluir: concluindoSATI,
                }}
                anexosCard={anexosCardContent}
                anexosCardRef={anexosCardRef}
                resumoIABar={resumoIABar}
                resumoActionsRight={resumoActionsRight}
                iaHabilitada={iaHabilitada}
                onSugerirPrioridade={buscarSugestaoPrioridade}
                prioridadeLoading={prioridadeLoading}
                onAlterarTipo={openModalTipo}
                ocultarEditor={abaAtiva === 'DESENVOLVIMENTO' || abaAtiva === 'HORAS'}
            />
            <div className="container-fluid d-flex ml-5">
                <Link to="/home" className="btn btn-secondary ms-auto mb-4 mt-3" type="button">Voltar</Link>
            </div>
            </main>
        </div>
    );
}

export default HistoricoSati;
